import React from 'react';
import PropTypes from 'prop-types';
import Styles from './DetailHeader.module.scss';

/**
 * The banner across the top of a detail page — Profile, DSO Group, Staff.
 *
 * Those three each carried their own copy of the same markup. The differences
 * that actually mattered are the three props: what the title says, whether
 * there is an avatar, and whether anything sits beside the title.
 *
 * `avatar` and `meta` are slots rather than typed props on purpose. Profile's
 * avatar is a click target wired to a hidden file input, and its meta is a
 * star image plus a rating; neither is worth modelling here when the caller
 * can just pass the node it already has.
 */
export const DetailHeader = ({ title, avatar, meta, tone }) => (
  <header className={`${Styles.header} ${Styles[tone]}`}>
    <div className={Styles.inner}>
      {avatar ? <div className={Styles.avatar}>{avatar}</div> : null}

      <div className={Styles.text}>
        <h2 className={Styles.title}>{title}</h2>
        {meta ? <div className={Styles.meta}>{meta}</div> : null}
      </div>
    </div>
  </header>
);

DetailHeader.propTypes = {
  title: PropTypes.node.isRequired,
  avatar: PropTypes.node,
  meta: PropTypes.node,
  /** `primary` is the professional profile; everything else is `neutral`. */
  tone: PropTypes.oneOf(['neutral', 'primary']),
};

DetailHeader.defaultProps = {
  avatar: null,
  meta: null,
  tone: 'neutral',
};

export default DetailHeader;
